// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
// custom components
import NumberedHeading from "../../../../../shared-components/forms/NumberedHeading";
import WYSIWYGEditor from "../../../../../shared-components/WYSIWYGEditor";
import MaterialsArray from './components/MaterialsArray';
import EmentorArray from '../shared/EmentorArray';

const PECapstoneHypothesisResponse = (props) => {
  const { control, formState } = props.methods;
  const { errors } = formState;
  const { inputDir } = props;

  return (
    <div>
      <NumberedHeading number="1" title="Prompt" instructions="What is the constructed response prompt?" />
      <Controller
        control={control}
        name="content.prompt"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.prompt} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="2" title="Response" instructions="Write the schoolhouse response that will be shown to the student to let them know what their response could have looked like." />
      <Controller
        control={control}
        name="content.response"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.response} />}
      />
      
    </div>
  );
};

export default PECapstoneHypothesisResponse;